module.exports = __webpack_public_path__ + "static/media/wating_back_2684cb5e87174ed809e7d7f579306e408.webp";